









































import Vue from '@front-app/vendor/vue';
import {
	computed,
	defineComponent,
	nextTick,
	PropType,
	ref,
	Ref,
} from '@vue/composition-api';
import { bytesToSize } from '@front-app/util/bytesToSize';
import { Content, ContentType } from '@front-app/services/GroupsApi/DiscussionModel';
import { ContentOrdering, ContentPageParams, ContentSort } from '@front-app/services/GroupsApi/GroupsContentApi';
import { Size } from '@front-app/components/constants';
import { toWildcardSearch } from '@front-app/util/contentSearch';
import { useThrottledFilesSearchSource } from '@front-app/hooks/ThrottledApi/fileSearch';
import SearchBox from '../search/SearchBox.vue';
import SearchPlaceholder from '../search/SearchPlaceholder.vue';
import SearchResult from '../search/SearchResult.vue';
import { useRollingIndex } from '../search/useRollingIndex';
import { SearchOption, useFileSearch } from '../search/useSearch';

const PAGE_SIZE = 100;

export default defineComponent({
	components: {
		SearchBox,
		SearchPlaceholder,
		SearchResult,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		excludedFiles: {
			type: Array as PropType<string[]>,
			default: () => [],
		},
		resultSize: {
			type: String as PropType<Size>,
			default: Size.MEDIUM,
		},
	},
	setup(props, ctx) {
		const {
			search: searchFiles,
			isLoading: isSearchLoading,
		} = useThrottledFilesSearchSource();
		const apiSearchResults: Ref<Content[]> = ref([]);
		const {
			searchString,
			results: filteredResults,
		} = useFileSearch(apiSearchResults);
		const params: Ref<ContentPageParams> = computed(() => ({
			search: toWildcardSearch(searchString.value),
			categories: [],
			types: [ContentType.FILE],
			order: ContentOrdering.DESCENDING,
			sort: ContentSort.NAME,
			pageSize: PAGE_SIZE,
		}));
		const el: Ref<null | Vue> = ref(null);
		const handleSearchItemClicked = async (content: SearchOption<Content>): Promise<void> => {
			searchString.value = '';
			ctx.emit('select', content);
			const elVal = el.value;
			if (!elVal) {
				return;
			}
			await nextTick();
			elVal.$el.querySelector('input')?.focus();
		};
		const searchFocus = useRollingIndex(filteredResults);
		const focusedSearchIdx = searchFocus.selectedIdx;
		const focusNextSearchResult = searchFocus.next;
		const focusPrevSearchResult = searchFocus.prev;
		const openFirstSearchResult = async () => {
			if (filteredResults.value.length === 0) {
				return;
			}
			await handleSearchItemClicked(filteredResults.value[0]);
		};
		const handleSearchInput = async (name: string) => {
			focusedSearchIdx.value = null;
			searchString.value = name;
			apiSearchResults.value = await searchFiles(props.groupId, 1, params.value);
		};

		const getTitle = (title: string, byteSize: number): string => {
			const fs = bytesToSize(byteSize);
			const quantity = ctx.root.$n(fs.quantity, 'short');
			return `${title} (${ctx.root.$t(fs.size, { quantity })})`;
		};
		return {
			el,
			getTitle,
			handleSearchItemClicked,
			filteredResults,
			searchString,
			isSearchLoading,
			handleSearchInput,
			focusedSearchIdx,
			focusNextSearchResult,
			focusPrevSearchResult,
			openFirstSearchResult,
		};
	},
});
